import DataLakeService from 'src/modules/dataLake/dataLakeService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'DATALAKE_FORM';

const dataLakeFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: dataLakeFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await DataLakeService.find(id);
      }

      dispatch({
        type: dataLakeFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: dataLakeFormActions.INIT_ERROR,
      });

      getHistory().push('/data-lake');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: dataLakeFormActions.CREATE_STARTED,
      });

      await DataLakeService.create(values);

      dispatch({
        type: dataLakeFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.dataLake.create.success'),
      );

      getHistory().push('/data-lake');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: dataLakeFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: dataLakeFormActions.UPDATE_STARTED,
      });

      await DataLakeService.update(id, values);

      dispatch({
        type: dataLakeFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.dataLake.update.success'),
      );

      getHistory().push('/data-lake');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: dataLakeFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default dataLakeFormActions;
